import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { InsightsJobActions, InsightsJobsSelectors, Job, TrackedJobState } from 'src/app/insights-jobs/state';

@Injectable({ providedIn: 'root' })
export class InsightsJobsService {
  public static readonly defaultMaxFailures = 3;

  public static readonly defaultPullInterval = 5000;

  constructor(private store: Store) {
  }

  public jobStarted(jobId: any, options?: InsightsJobStartedOptions): Observable<InsightsJobState> {
    this.store.dispatch(InsightsJobActions.onStarted({
      id: jobId,
      options: {
        maxFailures: options?.maxFailures ?? InsightsJobsService.defaultMaxFailures,
        pullInterval: options?.pullInterval ?? InsightsJobsService.defaultPullInterval
      }
    })); 

    let result$ = this.store.select(InsightsJobsSelectors.getTrackedJobState(jobId)).pipe(
      filter(s => !!s && !!s.job),
      map((s) => {
        return {
          job: { ...s.job },
          state: { ...s },
          completed: s.completed,
        };
      })
    );

    return result$;
  }
}

export interface InsightsJobState {
  job: Job;
  state: TrackedJobState;
  completed: boolean;
};

export interface InsightsJobStartedOptions {
  /** Number of times getting state can fail, before we assume the job has failed and can stop pulling. If 0, pulling will go indefinitely. */
  maxFailures?: number;

  /** Interval between state pulls. */
  pullInterval?: number;
};
